<template>
	<div class="close_over" v-if="isShow" @click.stop="hide">
		<div class="iconNo1">
			<img src="../assets/image/closeOverImgOne.png" alt="">
		</div>
		<p class="closeOverText">请在浏览器中打开，下载App</p>
		<div class="iconNo2">
			<img src="../assets/image/closeOverImgTwo.png" alt="">
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				isShow: false
			}
		},
		methods: {
			show(){
				this.isShow = true
			},
			hide(){
				this.isShow = false
				this.remove()
			}
		},
	}
</script>

<style lang="css" scoped>
.close_over {
	box-sizing: border-box;
	position: fixed;
	top: 0;
	left: 0;
	background-color: rgba(0, 0, 0, 0.6);
	width: 100%;
	height: 100%;
	padding: 0 1.5rem;
	z-index: 10;
}

.iconNo1 {
	display: flex;
	justify-content: flex-end;
}

.iconNo1 img {
	width: 14.55rem;
	height: 17.7rem;
	margin-right: 3rem;
}

.closeOverText {
	width: 100%;
	font-size: 2.2rem;
	color: #FFFFFF;
	justify-content: center;
	text-align: center;
	padding-bottom: 2rem;
}

.iconNo2 {
	display: flex;
	justify-content: center;
}

.iconNo2 img {
	width: 16.35rem;
	height: 5.25rem;
}

@media (min-width: 751px) {
	.close_over {
		width: 750px;
		left: 50%;
		margin-left: -375px;
	}
}
</style>
